const { getElements } = window.BAO.Utils
const KeenSlider = window.KeenSlider
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class DeviceSelector extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCarousels()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els?.trigger?.exists) {
      this.handleTrigger = this.handleTrigger.bind(this)

      this.els.trigger.elements.forEach(triggerEl => {
        this.listeners.add(triggerEl, `click`, this.handleTrigger)
      })
    }
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)

    this.els.panel.elements.forEach(panelEl => {
      panelEl.setAttribute(
        'aria-hidden',
        panelEl.dataset.tab !== triggerEl.dataset.tab,
      )
    })
    this.els.trigger.elements.forEach(trigger => {
      trigger.setAttribute(
        'aria-pressed',
        trigger.dataset.tab === triggerEl.dataset.tab,
      )
    })

    this.setupCarousels()
  }

  setupCarousels () {
    this.els.slides.elements.forEach(slidesEl => {
      const slidesCount = getElements('[data-device-selector-el="slide"]', {
        context: slidesEl,
      }).length

      if (window.innerWidth >= 901 && slidesCount < 7) {
        slidesEl.classList.add(this.dataset.notFullClass)
      } else if (window.innerWidth >= 768 && slidesCount < 5) {
        slidesEl.classList.add(this.dataset.notFullClass)
      }

      const slider = new KeenSlider(
        slidesEl,
        {
          selector: '.keen-slider__slide',
          loop: true,
          mode: 'snap',
          rubberband: false,
          slides: {
            perView: 3.5,
            spacing: 5,
          },
          breakpoints: {
            '(min-width: 768px)': {
              slides: {
                perView: 5,
                spacing: 0,
              },
            },
            '(min-width: 901px)': {
              slides: {
                perView: 7,
              },
            },
          },
          created: slider => this.updateSlideTabbing(slider),
          slideChanged: slider => this.updateSlideTabbing(slider),
          animationEnded: slider => this.updateSlideTabbing(slider),
          updated: slider => this.updateSlideTabbing(slider),
        },
        [
          setInitialised(),
          useArrows({
            container: slidesEl.querySelector(
              '[data-device-selector-el="arrows"]',
            ),
            next: slidesEl.querySelector('[data-device-selector-el="next"]'),
            previous: slidesEl.querySelector(
              '[data-device-selector-el="previous"]',
            ),
          }),
        ],
      )

      slidesEl.deviceSlider = slider

      if (!slidesEl.dataset.keyboardBound) {
        slidesEl.dataset.keyboardBound = 'true'

        this.handleArrowKeys = this.handleArrowKeys.bind(this)
        this.listeners.add(slidesEl, 'keydown', this.handleArrowKeys)
      }
    })
  }

  handleArrowKeys (event) {
    const slidesEl = event.currentTarget
    const slider = slidesEl.deviceSlider
    if (!slider) return

    if (event.key === 'ArrowLeft') {
      event.preventDefault()
      slider.prev()
    } else if (event.key === 'ArrowRight') {
      event.preventDefault()
      slider.next()
    }
  }

  updateSlideTabbing (slider) {
    const details = slider?.track?.details
    if (!details) return

    // fixes the previous and next items being tabble when offscreen

    const FULLY_VISIBLE = 0.99

    details.slides.forEach((slide, index) => {
      const link = slider.slides[index]?.querySelector('.util-FauxLink_Link')
      if (!link) return

      if (slide.portion >= FULLY_VISIBLE) {
        link.removeAttribute('tabindex')
      } else {
        link.setAttribute('tabindex', '-1')
      }
    })
  }
}

if (!customElements.get('device-selector')) {
  customElements.define('device-selector', DeviceSelector)
}
